import logo from './LostTribes.png';
import honeyComb from './honeyPoints.svg'
import honeyCombYellow from './honeyPointsYellow.svg'
import './Staking.css';
import { useAccount } from 'wagmi'
import { readContracts, readContract, prepareWriteContract, writeContract, waitForTransaction, watchAccount, disconnect } from '@wagmi/core'
import { useState } from 'react';
import Switch from "react-switch"
import ABI from './ABI.json'
import NFTABI from './ERC721ABI.json'
import Multipliers from './Multipliers.json'
import axios from 'axios'
import placeholder from './imagePlaceholder.svg'
import popupS from 'popups'
import './popupS.css'

const contractAddress = '0x4Ec902d04F4F1c840B28CffeE2E52d807af4710E';
const madHoney = '0x86c18085b8949ff3dc53ec5c3a3a143ccfbc960a';
const rivalBears = '0xa25541164ae9d59322b59fe94a73869b494c3691';
const ipfsURL = "https://rival-bears.infura-ipfs.io/ipfs/";
let rivalBearsURL;
let madHoneyURL;
let wallet;
let statsLoaded = false;
let lastInventoryLoad = 0;
const selected = [];
const rivalInventory = [];
const rivalStakes = [];
const madInventory = [];
const madStakes = [];

function StakingApp() {
  const [toggleStaked, setToggleStaked] = useState(false);
  const [toggleMadHoney, setToggleMadHoney] = useState(false);
  const [address, setAddress] = useState("0x00...0");
  const [bearsStaked, setBearsStaked] = useState("...");
  const [pointsEarnedLocale, setPointsEarnedLocale] = useState("...");
  const [pointsEarned, setPointsEarned] = useState(0);
  const [pointsClaimedLocale, setPointsClaimedLocale] = useState("...");
  const [pointsClaimed, setPointsClaimed] = useState(0);
  const [stakeText, setStakeText] = useState("Stake All");
  const [unstakeText, setUnstakeText] = useState("Unstake");
  const [display, setDisplay] = useState(displayLoading());
  const [loading, setLoading] = useState(false);
  const [staking, setStaking] = useState(false);
  const [unstaking, setUnstaking] = useState(false);

  useAccount({
    onConnect({ address }) {
      setShortWalletAddress(address);
      wallet = address;
      loadDisplay();
    },
    onDisconnect() {
      wallet = undefined;
      setAddress("0x00... 0");
      clearSelection();
      clearData();
    },
  });

  function setShortWalletAddress(address) {
    setAddress(address.substring(0, 6) + '... ' + address.substring(address.length - 4, address.length));
  }
  const unwatch = watchAccount(
    (account) => {
      if (wallet && account.address != wallet) {
        disconnect();
      }
    },
    { selector: ({ address }) => ({ address }) },
  );
  async function handleToggleStaked() {
    if (!loading) {
      clearSelection();
      const staked = !toggleStaked;
      setToggleStaked(staked);
      updateDisplay(toggleMadHoney, staked);
      return;
    }
    setToggleStaked(toggleStaked);
  }
  async function handleToggleMadHoney() {
    if (!loading) {
      clearSelection();
      const ogBears = !toggleMadHoney;
      setToggleMadHoney(ogBears);
      updateDisplay(ogBears, toggleStaked);
      return;
    }
    setToggleMadHoney(toggleMadHoney);
  }
  async function clearData() {
    rivalStakes.length = 0;
    rivalInventory.length = 0;
    madStakes.length = 0;
    madInventory.length = 0;
    setAddress("0x00...0");
    setBearsStaked("...");
    setPointsEarnedLocale("...");
    setPointsClaimedLocale("...");
    updateDisplay();
  }
  async function clearSelection() {
    selected.length = 0;
    const elements = document.getElementsByClassName("Selected");
    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove("Selected");
    }
    setStakeText("Stake All");
    setUnstakeText("Unstake");
  }
  function setPoints(claimed, earned) {
    setPointsClaimed(Number(claimed));
    setPointsEarned(Number(earned));
    setPointsClaimedLocale(claimed.toLocaleString());
    setPointsEarnedLocale(earned.toLocaleString());
  }
  async function delay(x) {
    await new Promise(resolve => setTimeout(resolve, x));
  }
  async function loadDisplay() {
    setLoading(true);
    if (statsLoaded == false) {
      statsLoaded = true;
      await delay(1400);
      await setMetadataURL();
    }
    loadStats();
    rivalStakes.length = 0;
    rivalInventory.length = 0;
    madStakes.length = 0;
    madInventory.length = 0;
    await loadStakes();
    await loadInventory();
  }

  function updateDisplay(madHoneySelected, staked) {
    if (loading) {
      return;
    }
    if (madHoneySelected) {
      if (staked) {
        if (madStakes.length > 0) {
          setDisplay(madStakes);
          return;
        }
      }
      else {
        if (madInventory.length > 0) {
          setDisplay(madInventory);
          return;
        }
      }
    }
    else {
      if (staked) {
        if (rivalStakes.length > 0) {
          setDisplay(rivalStakes);
          return;
        }
      }
      else {
        if (rivalInventory.length > 0) {
          setDisplay(rivalInventory);
          return;
        }
      }
    }
    setDisplay(emptyDisplay(madHoneySelected, staked));
    setLoading(false);
  }

  async function loadStats() {
    const data = await readContracts({
      contracts: [
        {
          address: contractAddress,
          abi: ABI,
          functionName: 'getStakerUnharvestedPoints',
          args: [wallet],
        },
        {
          address: contractAddress,
          abi: ABI,
          functionName: 'getStakerAccumulatedHarvestedPoints',
          args: [wallet],
        }
      ],
    });
    let { claimed, earned } = {
      earned: data[0].status == "success" ? data[0].result : 0,
      claimed: data[1].status == "success" ? data[1].result : 0,
    };
    setPoints(claimed, earned);
  }

  /*async function srcBase64(url){
    const uA = window.navigator.userAgent;
    const vendor = window.navigator.vendor;
    if (!(/Safari/i.test(uA) && /Apple Computer/.test(vendor))) {
      //Not Desktop Safari
      return url;
    }
    let type;
    if (url.indexOf('png') >= 0) {
      type = "png";
    }
    else {
      type = "jpeg";
    }
    //const base64 = Buffer.from(url).toString('base64');
    let image = await axios.get(url, { responseType: 'arraybuffer' });
    let returnedB64 = Buffer.from(image.data).toString('base64');
    return  `data:image/${type};base64,${returnedB64}`;
  }*/

  async function setMetadataURL() {
    await readContracts({
      contracts: [
        {
          address: rivalBears,
          abi: NFTABI,
          functionName: 'tokenURI',
          args: [0],
        },
        {
          address: madHoney,
          abi: NFTABI,
          functionName: 'tokenURI',
          args: [0],
        }
      ],
    }).then((data) => {
      // slice(4,-7) -> ipfs://bafybeifziei2rtbqqitk2pwcknw2qadruzbtrvsca6dilhsf6ewqvfueui/0.json
      //https://bafybeifmy7mqifmbdq3bwnxehhpm625as3onsyzm6lmdaroc2r5nkyhwmy.ipfs.nftstorage.link/0.json
      //rivalBearsURL = "https" + data[0].result.slice(4,-7) + ".ipfs.nftstorage.link/";
      rivalBearsURL = "https://rival-bears.infura-ipfs.io/ipfs/" + data[0].result.slice(7, -7) + "/";
      //madHoneyURL = "https" + data[1].result.slice(4,-7) + ".ipfs.nftstorage.link/";
      madHoneyURL = "https://rival-bears.infura-ipfs.io/ipfs/" + data[1].result.slice(7, -7) + "/";
      //console.log(madHoneyURL);
    }).catch(() => { })
  }

  async function toggleStakeSelection(index, element) {
    const selectionIndex = selected.indexOf(index);
    //if element is aready selected then unselect it
    if (selectionIndex > -1) {
      element.classList.remove("Selected");
      selected.splice(selectionIndex, 1);
      if (selected.length != 0) {
        setUnstakeText("Unstake (" + selected.length + ")");
      }
      else {
        setUnstakeText("Unstake");
      }
      return;
    }
    //else remove class from selected stake and add class to new selection
    await clearSelection();
    element.classList.add("Selected");
    selected.push(index);
    setUnstakeText("Unstake (" + selected.length + ")");
  }

  function getImageURL(uri){
    if(uri.substring(0,7) == "ipfs://"){
      return ipfsURL + uri.substring(6);
    }
    else{
      return ipfsURL + 
      uri.substring(uri.indexOf("//") + 2, uri.indexOf("."))+
      uri.substring(uri.lastIndexOf('/'));
    }
  }

  async function getStakingCard(stakingIndex, nft, tokenId) {
    let collection;
    let url;
    let metadata;
    let multiplier = 100;
    if (nft.toLowerCase() != madHoney.toLowerCase()) {
      metadata = rivalBearsURL + tokenId + ".json";
      collection = rivalBears;
    }
    else {
      collection = madHoney;
      metadata = madHoneyURL + tokenId + ".json";
      //console.log(metadata);
    }
    //console.log(metadata);
    await axios.get(metadata).then((response) => {
      url = response.data.image;
      //console.log(url);
      if (nft != madHoney) {
        let attribute, value;
        for (let i = 0; i < response.data.attributes.length; i++) {
          attribute = response.data.attributes[i].trait_type;
          value = response.data.attributes[i].value;
          if (attribute in Multipliers && value in Multipliers[attribute]) {
            multiplier += Multipliers[attribute][value];
          }
        }
      }
    }).catch(error => {}); 
    //console.log(url);
    //url = await srcBase64(url);
    url = getImageURL(url).replace("ipfs//","ipfs/");
    return <div className={`Card`} url={url} collection={collection} tokenid={tokenId} multiplier={multiplier} key={"Stake#"+stakingIndex}>
        #{tokenId} <span>✖</span> {multiplier}%
        <img src={url} onClick={(event)=>{toggleStakeSelection(stakingIndex,event.target)}}/>
        {/*
          (navigator?.userAgent?.search('Safari') >= 0) ?
          <img src={url} onClick={(event)=>{toggleStakeSelection(stakingIndex,event.target)}}/> :
          <img src={placeholder} data-src={url} loading='lazy' onClick={(event)=>{toggleStakeSelection(stakingIndex,event.target)}}/>
        */}
      </div>;
  }

  async function loadStakes() {
    const data = await readContract({
      address: contractAddress,
      abi: ABI,
      functionName: 'getStakes',
      args: [wallet],
    }).catch({});

    if (data == undefined) {
      setBearsStaked(0);
      return;
    }

    setBearsStaked(data.length);
    let stakingCard;
    for (let i = 0; i < data.length; i++) {
      stakingCard = await getStakingCard(i, data[i].nft, Number(data[i].tokenId));
      if (data[i].nft.toLowerCase() == rivalBears.toLowerCase()) {
        rivalStakes.push(stakingCard);
      }
      else {
        madStakes.push(stakingCard);
      }
      await delay(300);
    }
  }

  function displayLoading() {
    return <h3 className='Dots EmptyDisplay'>
      Loading
      <span className='Dot Dot1'>.</span>
      <span className='Dot Dot2'>.</span>
      <span className='Dot Dot3'>.</span>
    </h3>;
  }
  
  function toggleInventorySelection(contract_address, token_id, element) {
    //asset.contract_address > string
    //asset.token_id > string
    const NFT = {
      address: contract_address,
      tokenId: token_id,
    }
    let selectionIndex = selected.findIndex((arrayObject) => {
      return (arrayObject.address == NFT.address && arrayObject.tokenId == NFT.tokenId);
    });
    if (selectionIndex > -1) {
      element.classList.remove("Selected");
      selected.splice(selectionIndex, 1);
    }
    else {
      element.classList.add("Selected");
      selected.push(NFT);
    }
    if (selected.length != 0) {
      setStakeText("Stake (" + selected.length + ")");
    }
    else {
      setStakeText("Stake All");
    }
  }

  async function getInventoryCard(asset) {
    //const multiplier = "100";
    //TODO get staking percent multiplier with wagmi viem
    //console.log(srcBase64(asset.content_uri));
    //console.log(asset.);
    let multiplier = 100;
    const metadata = JSON.parse(asset.metadata_json);
    let attribute, value;
    for (let i = 0; i < metadata.attributes.length; i++) {
      attribute = metadata.attributes[i].trait_type;
      value = metadata.attributes[i].value;
      if (attribute in Multipliers && value in Multipliers[attribute]) {
        multiplier += Multipliers[attribute][value];
      }
    }
    const url = getImageURL(asset.content_uri).replace("ipfs//","ipfs/");
    return <div className="Card" key={asset.contract_address+asset.token_id}>
      #{asset.token_id} <span>✖</span> {multiplier}%
      <br/>
      <img src={url} onClick={(event)=>{toggleInventorySelection(asset.contract_address,asset.token_id,event.target)}}/>
      {/*<img src={`${await srcBase64(asset.content_uri)}`}/>*/}
      {/*
        (navigator?.userAgent?.toLowerCase.search('Macintosh') >= 0) || (navigator?.userAgent?.toLowerCase.search('AppleWebKit') >= 0) ?
        <img src={url} onClick={(event)=>{toggleInventorySelection(asset.contract_address,asset.token_id,event.target)}}/> :
        <img src={placeholder} data-src={url} loading='lazy' onClick={(event)=>{toggleInventorySelection(asset.contract_address,asset.token_id,event.target)}}/>
      */}
    </div>;
  }

  async function fetchNFTs(nftAddress) {
    const nfts = [];
    let nextPage;
    let response;
    let count = 0;
    do {
      //response = await axios.get(`https://polygonapi.nftscan.com/api/v2/account/own/0x4c36d7c23defc1187126ec97f2481bbe518646a8`, {
      response = await axios.get(`https://polygonapi.nftscan.com/api/v2/account/own/${wallet}`, {
        headers: {
          'X-API-KEY': 'FdQ0N9LCyiyCryprRraEJohO'
        },
        params: {
          contract_address: nftAddress,
          erc_type: "erc721",
          show_attribute: false,
          limit: 100,
          cursor: nextPage
        }
      });
      if (response.data.data != null) {
        let card;
        for(let x of response.data.data.content){
          card = await getInventoryCard(x);
          nfts.push(card);
        }
        nextPage = response.data.data.next;
        count += response.data.data.content.length;
        if (count == response.data.data.total) {
          nextPage = null;
        }
      }
    }
    while (nextPage != null)
    nfts.sort((a, b) => Number(a.key.substring(42)) - Number(b.key.substring(42)));
    return nfts;
  }

  async function loadInventory() {
    let numRivalBears = 0;
    let numMadHoney = 0;
    await readContracts({
      contracts: [
        {
          address: rivalBears,
          abi: NFTABI,
          functionName: 'balanceOf',
          args: [wallet],
        },
        {
          address: madHoney,
          abi: NFTABI,
          functionName: 'balanceOf',
          args: [wallet],
        }
      ],
    }).then((data) => {
      numRivalBears = Number(data[0].result);
      numMadHoney = Number(data[1].result);
    }).catch(() => { })

    const time = Date.now();
    const elapsed = time - lastInventoryLoad;
    const rateLimit = 10000;
    if (elapsed < rateLimit) {
      //window.alert("Excessive requests!\nHold on...");
      await delay(rateLimit - elapsed);
    }
    lastInventoryLoad = Date.now();
    if (numRivalBears > 0) {
      rivalInventory.push(...(await fetchNFTs(rivalBears)));
    }
    if (numMadHoney > 0) {
      madInventory.push(...(await fetchNFTs(madHoney)));
    }
    displayLoading();
    setLoading(false);
    updateDisplay(toggleMadHoney, toggleStaked);
  }

  async function stake() {
    if (wallet == undefined) {
      //window.alert("Wallet not Detected");
      popupS.alert({
        title: "Error",
        content: "Wallet not Detected"
      });
      return;
    }
    if (staking) {
      return;
    }
    setStaking(true);
    let selectedNFTs;
    let nftAddress;
    if (toggleMadHoney) {
      nftAddress = madHoney;
      if (stakeText == "Stake All") {
        selectedNFTs = [];
        madInventory.forEach((element) => selectedNFTs.push({
          address: element.key.substring(0, 42),
          tokenId: element.key.substring(42),
        }));
      }
      else {
        selectedNFTs = selected;
      }
    }
    else {
      nftAddress = rivalBears;
      if (stakeText == "Stake All") {
        selectedNFTs = [];
        rivalInventory.forEach((element) => selectedNFTs.push({
          address: element.key.substring(0, 42),
          tokenId: element.key.substring(42),
        }));
      }
      else {
        selectedNFTs = selected;
      }
    }
    if (selectedNFTs.length == 0) {
      //window.alert("No Bears Selected");
      popupS.alert({
        title: "Error",
        content: "Nothing selected from wallet"
      });
      setStaking(false);
      return;
    }
    if (await confirmApproval(nftAddress) == false) {
      setStaking(false);
      return;
    }
    let config, failed, reload;
    if (selectedNFTs.length == 1) {
      config = await prepareWriteContract({
        address: contractAddress,
        abi: ABI,
        functionName: 'stake',
        args: [selectedNFTs[0].address, selectedNFTs[0].tokenId],
      }).catch((error) => {
        //window.alert("Txn will fail");
        //console.log(error);
      });
      if(config){
        failed = await sendTxn(config);
      }
      if(!failed){
        reload=true;
      }
    }
    else {
      const addresses = [];
      const tokenIds = [];
      for (let i = 0; !failed && i < selectedNFTs.length; i++) {
        addresses.push(selectedNFTs[i].address);
        tokenIds.push(selectedNFTs[i].tokenId);
        if (tokenIds.length == 20 || i == selectedNFTs.length-1) {
          failed = await stakeMultiple(addresses,tokenIds);
          if(!failed){
            reload=true;
          }
          addresses.length=0;
          tokenIds.length=0;
        }
      }
    }
    if(reload){
      displayLoading();
      await loadDisplay();
    }
    setStaking(false);
  }

  async function stakeMultiple(addresses,tokenIds) {
    let failed,config;
    try {
      config = await prepareWriteContract({
        address: contractAddress,
        abi: ABI,
        functionName: 'stakeMultiple',
        args: [addresses, tokenIds],
      }).catch((error) => {
        console.log(error)
        //window.alert("Cannot Unstake")
      });
      if (config == undefined) {
        failed = true;
      }
      else {
        failed = await sendTxn(config);
      }
    } catch {
      failed = true;
    }
    return failed;
  }

  async function confirmApproval(nftAddress) {
    let passed = false;
    const data = await readContract({
      address: nftAddress,
      abi: NFTABI,
      functionName: 'isApprovedForAll',
      args: [wallet, contractAddress],
    });
    if (data == true) {
      return true;
    }
    passed = true;
    const {hash} = await writeContract({
      address: nftAddress,
      abi: NFTABI,
      functionName: 'setApprovalForAll',
      args: [contractAddress, true],
    }).catch((error) => { passed = false });
    if (passed) {
      await waitForTransaction({
        confirmations: 1,
        hash: hash
      }).catch((error) => {
        //window.alert("Txn will fail");
        //console.log(error);
        passed = false;
      });
    }
    return passed;
  }

  async function claim() {
    if (wallet == undefined) {
      //window.alert("Wallet not Detected");
      popupS.alert({
        title: "Error",
        content: "Wallet not Detected"
      });
      return;
    }
    let config = await prepareWriteContract({
      address: contractAddress,
      abi: ABI,
      functionName: 'harvestAllStakes',
    }).catch((error) => { 
      //window.alert("Cannot Harvest")
      popupS.alert({
        title: "Error",
        content: "Cannot Claim Points"
      });
    });
    if (config != undefined) {
      if(await sendTxn(config) == false){
        setPoints(window.BigInt(pointsClaimed + pointsEarned), window.BigInt(0));
      }
    }
  }

  async function unStake() {
    //console.log(selected)
    if (unstaking) {
      return;
    }
    setUnstaking(true);
    if (wallet == undefined) {
      //window.alert("Wallet not Detected");
      popupS.alert({
        title: "Error",
        content: "Wallet not Detected"
      });
      setUnstaking(false);
      return;
    }
    let selectedNFTs = selected;
    if (selectedNFTs.length == 0) {
      //window.alert("No Stakes Selected");
      popupS.alert({
        title: "Error",
        content: "No Stakes Selected"
      });
      setUnstaking(false);
      return;
    }
    let config, failed, reload;
    if (selectedNFTs.length == 1) {
      config = await prepareWriteContract({
        address: contractAddress,
        abi: ABI,
        functionName: 'unstake',
        args: [selectedNFTs[0]],
      }).catch((error) => { 
        //window.alert("Cannot Unstake")
        popupS.alert({
          title: "Error",
          content: "Cannot Unstake"
        });
      });
      if(config != undefined){
        failed = await sendTxn(config);
        if(!failed){
          reload = true;
        }
      }
    }
    else {
      const stakingIds = [];
      for (let i = 0; !failed && i < selectedNFTs.length; i++) {
        stakingIds.push(selectedNFTs[i]);
        if (stakingIds.length == 20 || i == selectedNFTs.length-1) {
          failed = await unstakeMultiple(stakingIds);
          if(!failed){
            reload = true;
          }
          //console.log(failed)
          stakingIds.length=0;
        }
      }
    }
    if(reload){
      //generate new inventory cards and remove the old cards
      let element, isMadHoney, removalIndex;
      for(let i=0;!element && i<selected.length;i++){
        for(let j=0;j<madStakes.length;j++){
          if(Number.parseInt(madStakes[j].key.substring(6)) == Number.parseInt(selected[i])){
            element = madStakes[j];
            removalIndex = j;
            isMadHoney = true;
          }
        }
        for(let j=0;!element && j<rivalStakes.length;j++){
          if(Number.parseInt(rivalStakes[j].key.substring(6)) == Number.parseInt(selected[i])){
            element = rivalStakes[j];
            removalIndex = j;
          }
        }
        if(element){
          if(isMadHoney){
            const newInventoryCard = convertStakingCard(element);
            madStakes.splice(removalIndex,1);
            madInventory.unshift(newInventoryCard);
          }
          else{
            const newInventoryCard = convertStakingCard(element);
            rivalStakes.splice(removalIndex,1);
            rivalInventory.unshift(newInventoryCard);
          }
        }
      }
      if(element){
        setLoading();
        updateDisplay(toggleMadHoney,toggleStaked);
      }
    }
    setUnstaking(false);
  }

  function convertStakingCard(stakingCard){
    //console.log(stakingCard);
    //console.log(stakingCard.props.url);   
    return <div className="Card" key={stakingCard.props.collection+stakingCard.props.tokenid}>
      #{stakingCard.props.tokenid} <span>✖</span> {stakingCard.props.multiplier}%
      <br/>
      <img src={stakingCard.props.url} onClick={(event)=>{toggleInventorySelection(stakingCard.props.collection,stakingCard.props.tokenid,event.target)}}/>
      {/*
        (navigator?.userAgent?.search('Safari') >= 0) ?
        <img src={stakingCard.props.url} onClick={(event)=>{toggleInventorySelection(stakingCard.props.collection,stakingCard.props.tokenid,event.target)}}/> :
        <img src={placeholder} data-src={stakingCard.props.url} loading='lazy' onClick={(event)=>{toggleInventorySelection(stakingCard.props.collection,stakingCard.props.tokenid,event.target)}}/>
      */}
    </div>;
  }

  async function sendTxn(config){
    let failed;
    const {hash} = await writeContract(config).catch((error) => {
      failed = true;
      console.log("write error");
    });
    //console.log(hash);
    if (failed == undefined) {
      await waitForTransaction({
        confirmations: 2,
        hash
      }).catch((error) => {
        console.log(error);
        failed=true;
        //console.log("wait for txn error");
      });
    }
    return failed;
  }

  async function unstakeMultiple(stakingIds){
    let failed,config;
    try {
      config = await prepareWriteContract({
        address: contractAddress,
        abi: ABI,
        functionName: 'unstakeMultiple',
        //args: [stakingIds],
        args: [stakingIds],
      }).catch((error) => {
        console.log(error)
        //window.alert("Cannot Unstake")
      });
      if (config == undefined) {
        failed = true;
      }
      else {
        failed = await sendTxn(config);
      }
    } catch {
      failed = true;
    }
    return failed;
  }

  function emptyDisplay(madHoneySelected, staked) {
    let message, action;
    if (!staked) {
      message = "No Bears in your wallet!";
      if (!madHoneySelected) {
        action = <a target="_blank" href="https://magiceden.io/collections/polygon/rival_bears">Get your bears here</a>;
      }
      else {
        action = <a target="_blank" href="https://magiceden.io/collections/polygon/mad_honey">Get your bears here</a>;
      }
    }
    else {
      message = "No bears staked!";
    }

    return <div className='EmptyDisplay'>
      {message}
      <br />
      {action}
    </div>
  }
  return (
    <div id="StakingApp" className="StakingApp StakingAppHidden">
      <header className="Header">
        <div className="Logo" alt="logo">
          RIVAL BEARS&nbsp;
        </div>
      </header>
      <center>
        <button className='Address StakingText'>
          {address}
        </button>
        <div className='StakingDiv StakingText'>
          <div className='StakingMessage'>
            Stake your Rival Bears
          </div>
          Each bear staked earns 60 honey points per day. The original Rival Bears collection has boosts for certain traits!
          <div className='StakingStats'>
            <div>
              <img src={logo} />
              Bears <br />&nbsp;&nbsp;Staked&nbsp;&nbsp;
              <br />
              {bearsStaked}
            </div>
            <div>
              <img src={honeyCombYellow} />
              Honey Points <br />Earned
              <br />
              {pointsEarnedLocale}
            </div>
            <div>
              <img src={honeyComb} />
              Points <br />Claimed
              <br />
              {pointsClaimedLocale}
            </div>
          </div>
          <div className='FlexDiv'>
            <button className='StakingButton' onClick={stake}>
              {stakeText}
            </button>
            <button className='StakingButton' onClick={claim}>
              Claim Points
            </button>
            <button className='StakingButton' onClick={unStake}>
              {unstakeText}
            </button>
          </div>
          <div className='FlexDiv'>
            <label>
              Rival Bears
              <Switch className='Toggle'
                onChange={handleToggleMadHoney}
                checked={toggleMadHoney}
                offColor='#FF3333'
                onColor='#FBD300'
                disabled={loading}
                handleDiameter={14}
                uncheckedIcon={false}
                checkedIcon={false}
                aria-label="Toggle Rival Bears & Mad Honey" />
              Mad Honey
            </label>
            <label>
              Unstaked
              <Switch className='Toggle'
                onChange={handleToggleStaked}
                checked={toggleStaked}
                offColor='#a7a7a7'
                onColor='#000000'
                disabled={loading}
                handleDiameter={14}
                uncheckedIcon={false}
                checkedIcon={false}
                aria-label="Toggle Inventory & Stakes" />
              Staked
            </label>
          </div>
          <hr />
          <div className='Display'>
            {display}
          </div>
        </div>
      </center>
    </div>
  );
}

export default StakingApp;